// extracted by mini-css-extract-plugin
export default {"section":"DemandAnalysis_section__qSE5j","summaryGrid":"DemandAnalysis_summaryGrid__8Vg8o","summaryCard":"DemandAnalysis_summaryCard__+nLzi"};